import PropTypes from 'prop-types';
import React from 'react';
import FluidImage from '@utility/FluidImage';
import Link from '@utility/Link';
import ScrollInView from '@utility/ScrollInView';
import * as styles from './styles.module.scss';

const Driver = ({ data: { heading, links } }) => (
  <div>
    <ScrollInView>
      <div className="wrapper">
        <div className="row">
          <div className="col-12 md:col-6 md:offset-1">
            <h2 className="mb-6 md:mb-20 type-sans-630 md:type-sans-930">
              {heading}
            </h2>
          </div>
        </div>
      </div>
    </ScrollInView>
    <ScrollInView>
      <div className="wrapper">
        <div className="row">
          {links &&
            links.map((link) => (
              <div key={link._key} className="col-12 md:col-4">
                <div className={`${styles.card} md-down:mb-10`}>
                  <FluidImage
                    className={`${styles.cardImage} mb-2 md:mb-5`}
                    src={link.image}
                    maxWidth={852}
                    maxHeight={568}
                  />
                  <h3 className="type-sans-430 md:type-sans-630">
                    {link.link && (
                      <Link
                        to={link.link[0]}
                        className={styles.cardLink}
                        styled={false}
                        internalExternal
                        aria-label={link.link[0].label}
                      >
                        {link.link[0].label}
                      </Link>
                    )}
                  </h3>
                </div>
              </div>
            ))}
        </div>
      </div>
    </ScrollInView>
  </div>
);

Driver.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.object).isRequired,
  }),
};

Driver.defaultProps = {
  data: {
    heading: '',
    links: [],
  },
};

export default Driver;
